import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid-pro";
import { ArticleStatus } from "entities/manageArticles/types";
import Chip from "shared/components/Chip";
import FilledFileIcon from "shared/theme/icons/FilledFileIcon";
import { formatUpdatedAt } from "shared/utils/formatUpdatedAt";
import { getChipColor } from "../../utils";
import TableDropdown from "./components/TableDropdown";
import { statusTitles } from "./constants";

const renderStatusCell = (params: GridRenderCellParams) => {
  const color = getChipColor(params.value as ArticleStatus);
  const title = statusTitles[params.value as ArticleStatus];
  return <Chip title={title} bgColor={color} />;
};

export const getArticlesGroupColumns = (): GridColDef[] => {
  return [
    {
      field: "id",
      headerName: "",
      editable: false,
      flex: 0.1,
      sortable: false,
      renderCell: FilledFileIcon,
    },
    {
      field: "name",
      headerName: "Title",
      editable: false,
      flex: 1,
      sortable: false,
    },
    {
      field: "version",
      headerName: "Version",
      editable: false,
      sortable: false,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "language",
      headerName: "Language",
      editable: false,
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => params.row.language.toUpperCase(),
    },
    {
      field: "updatedAt",
      headerName: "Updated At",
      editable: false,
      sortable: false,
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => formatUpdatedAt(params.value),
    },
    {
      field: "status",
      headerName: "Status",
      editable: false,
      sortable: false,
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => renderStatusCell(params),
    },
    {
      field: "actions",
      headerName: "",
      editable: false,
      sortable: false,
      align: "right",
      headerAlign: "right",
      renderCell: (params) => <TableDropdown params={params} />,
    },
  ];
};
